import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-alert',
  templateUrl: './dialog-alert.component.html',
  styleUrls: ['./dialog-alert.component.scss']
})
export class DialogAlertComponent {
    msg: string;
    showAll:boolean;

constructor(
  private dialogRef: MatDialogRef<DialogAlertComponent>,
  @Inject(MAT_DIALOG_DATA)
  public data:
  {
    msg: string,
    showAll: boolean
  }
) {
  this.msg = data.msg;
  this.showAll = data.showAll;
}

  aceptar() {
    if(this.showAll == true){
      this.dialogRef.close('aceptar');
    }else{
      this.dialogRef.close('aceptar-not-continued');
    }
  }

  cancelar() {
    this.dialogRef.close('cancelar');
  }
}
